var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.2 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-12{fill:#198754;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Driver Using Mobile App") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M19.2,0H5.2a2,2,0,0,0-2,2V5a.94.94,0,0,0,1,1,.94.94,0,0,0,1-1V4h14V24H5.2V23a.94.94,0,0,0-1-1,.94.94,0,0,0-1,1v3a2,2,0,0,0,2,2h14a2,2,0,0,0,2-2V2A2,2,0,0,0,19.2,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M4.6,19l.6-.6,7-7,.9-.9a1,1,0,0,0,0-1.4,1.22,1.22,0,0,0-.9-.3.76.76,0,0,0-.5.2L5.2,15.5,3.9,16.8l-.7-.7L1.7,14.7a.91.91,0,0,0-.7-.3.91.91,0,0,0-.7.3,1,1,0,0,0,0,1.4L3.2,19h0a1,1,0,0,0,1.4,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileUser);
export default __webpack_public_path__ + "static/media/mobileUser.16c16e2a677b41007b83abc9e3c93e5b.svg";
export { ForwardRef as ReactComponent };